// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { orderInfoStyle } from "@hardwoods/App/WidgetExtensions/MyAccountPagesSharedStyle/DetailsPages/OrderInfoStyle";
import { rfqQuoteDetailsInformationStyles } from "@hardwoods/Overrides/Widgets/RfqQuoteDetails/RfqQuoteDetailsInformation";
import { mergeWithCss } from "@hardwoods/XDL/Utilities/mergeWithCss";
import { css } from "styled-components";

const sharedStyle = {
    wrapper: {
        css: css`
            display: flex;
            flex-direction: row;
        `,
    },
    heading: {
        ...mergeWithCss(orderInfoStyle.orderLabel, {
            css: css`
                text-transform: capitalize;
                margin-right: 5px;
            `,
        }),
    },
    text: {
        ...orderInfoStyle.orderValue,
    },
};

rfqQuoteDetailsInformationStyles.expirationDateGridItem = {
    width: 12,
};

rfqQuoteDetailsInformationStyles.expirationDateDatePicker = {
    cssOverrides: {
        datePicker: css`
            width: auto;
        `,
    },
};

rfqQuoteDetailsInformationStyles.jobNameGridItem = {
    width: [12, 12, 12, 12, 12],
    printWidth: 12,
    css: css`
        @media print {
            max-width: 100%;
        }
    `,
};

rfqQuoteDetailsInformationStyles.salesRepGridItem = {
    width: [12, 12, 12, 12, 6],
    printWidth: 12,
    css: css`
        @media print {
            max-width: 100%;
        }
    `,
};

rfqQuoteDetailsInformationStyles.userGridItem = {
    width: [12, 12, 12, 12, 6],
    printWidth: 12,
    css: css`
        @media print {
            max-width: 100%;
        }
    `,
};

rfqQuoteDetailsInformationStyles.statusGridItem = {
    width: [12, 12, 12, 12, 12],
    printWidth: 12,
    css: css`
        @media print {
            max-width: 100%;
        }
    `,
};

rfqQuoteDetailsInformationStyles.dateGridItem = {
    width: [12, 12, 12, 12, 4],
    printWidth: 12,
    css: css`
        flex-direction: row;
        @media print {
            max-width: 100%;
        }
    `,
};

rfqQuoteDetailsInformationStyles.expirationDateLabelText = sharedStyle.heading;

rfqQuoteDetailsInformationStyles.jobNameHeadingAndText = sharedStyle;

rfqQuoteDetailsInformationStyles.salesRepHeadingAndText = sharedStyle;

rfqQuoteDetailsInformationStyles.userHeadingAndText = sharedStyle;

rfqQuoteDetailsInformationStyles.statusHeadingAndText = sharedStyle;

rfqQuoteDetailsInformationStyles.customerHeadingAndText = sharedStyle;

rfqQuoteDetailsInformationStyles.shipToHeadingAndText = sharedStyle;

rfqQuoteDetailsInformationStyles.poNumberHeadingAndText = sharedStyle;

rfqQuoteDetailsInformationStyles.notesHeadingAndText = sharedStyle;

rfqQuoteDetailsInformationStyles.dateLabelText = {
    ...mergeWithCss(orderInfoStyle.orderLabel, {
        css: css`
            margin-right: 5px;
        `,
    }),
};
